import { RadioIcon } from "../icon/icons/radio-icon/RadioIcon";
import styles from "./Radio.module.css";

export interface RadioProps {
  id?: string;
  name?: string;
  checked?: boolean;
  highlight?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export const Radio: React.FC<RadioProps> = ({
  id,
  name,
  checked,
  highlight,
  disabled,
  onChange,
}) => {
  return (
    <label className={styles.radio} htmlFor={id}>
      <input
        id={id}
        className={styles.input}
        type="checkbox"
        name={name}
        checked={checked}
        disabled={disabled}
        hidden
        onChange={(event) => onChange?.(event.target.checked)}
      />
      <RadioIcon
        className={styles.icon}
        active={checked}
        highlight={highlight}
        disabled={disabled}
      />
    </label>
  );
};
